export const appInsideIframe = window.location !== window.parent.location;
